<div class="free-subscription position-absolute w-100 min-vh-100 d-flex justify-content-center align-items-center p-4">
  <div class="card border-0 text-center p-4 p-md-5 w-100">
    <h1 class="mb-3">You're on the QuickBoard Free plan</h1>
    <p class="message mb-3">
      The free subscription is designed for use on our iOS app.
      Web access is limited — please download the QuickBoard app on your iPhone or iPad
      to continue using your account.
    </p>
    <p class="hint mb-4">
      To unlock the full web experience, upgrade to a paid plan from within the iOS app
      or contact your administrator.
    </p>

    <div class="actions d-flex flex-column align-items-stretch">
      <button type="button" class="btn btn-block primary" routerLink="/upgrade-subscription">
        Upgrade subscription
      </button>
      <button type="button" class="btn btn-block secondary" (click)="openAppStore()">
        Download on the App Store
      </button>
      <button type="button" class="btn btn-block tertiary" (click)="logout()">
        Log out
      </button>
    </div>
  </div>
</div>
